import type { Location } from 'react-router-dom';

/**
 * Router state carried by overlay routes (e.g. `/track/:orderId`) so the page
 * they were opened from keeps rendering underneath the overlay.
 */
export interface IBackgroundLocationState {
  backgroundLocation?: Location;
}

/** Returns the page location an overlay route was opened on top of, if any. */
export const getBackgroundLocation = (location: Location): Location | undefined =>
  (location.state as IBackgroundLocationState | null)?.backgroundLocation;
